// extracted by mini-css-extract-plugin
export default {"oddRow":"LookupsUserRights_oddRow__-GCY6","evenRow":"LookupsUserRights_evenRow__HeZcX","card":"LookupsUserRights_card__pYM4Z"};